/**
 * CVC Customer Details Component
 * Main component that displays CVC Customers dashboard
 */

import React from "react";
import { Icon, MessageBar, MessageBarType } from "@fluentui/react";
import { CVCCustomerCustomersTab } from "./CVCCustomerCustomersTab";
import { CVC_CUSTOMER_STYLES } from "./CVCCustomer.styles";
import { ICVCCustomerDetailsProps } from "./CVCCustomer.interfaces";

export const CVCCustomerDetails: React.FC<ICVCCustomerDetailsProps> = ({ isLoading = false }) => {
    return (
        <div className={CVC_CUSTOMER_STYLES.pageRoot}>
            {/* Page header with logo badge */}
            <div className={CVC_CUSTOMER_STYLES.pageHeader}>
                <div className={CVC_CUSTOMER_STYLES.headerLeft}>
                    <div className={CVC_CUSTOMER_STYLES.headerLogoBadge}>
                        <Icon iconName="People" />
                    </div>
                    <div>
                        <div className={CVC_CUSTOMER_STYLES.pageHeaderTitle}>CVC Customer Association</div>
                        <div className={CVC_CUSTOMER_STYLES.pageHeaderSubtitle}>
                            Solution & Customer Tracking · Active within last 180 days
                        </div>
                    </div>
                </div>
            </div>

            {/* Warning Banner */}
            <div className={CVC_CUSTOMER_STYLES.warningBanner}>
                <MessageBar
                    messageBarType={MessageBarType.severeWarning}
                    isMultiline={false}
                    styles={{
                        root: {
                            background: "#FFF4CE",
                            borderRadius: 0,
                            border: "none",
                            borderBottom: "1px solid #E6E6E6"
                        },
                        icon: { color: "#797775" },
                        text: { color: "#323130" }
                    }}
                >
                    Note: This dashboard includes CAT customer engagements from the last six months for which a PM has been assigned and corresponding engagement notes are available. Please note that CARE and CCP engagements are not included in this view.
                </MessageBar>
            </div>

            {/* CVC Customer Content */}
            <CVCCustomerCustomersTab isLoading={isLoading} />
        </div>
    );
};
